import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as utils from '@/utils/utils';
import _ from 'lodash';
import Velocity from 'velocity-animate';

/**
 * 保证同时只有一个键盘存在
 */
let globalKeyboard: BaseKeyboard | undefined;
/**
 * 自定义键盘基类
 */
@Component({
})
export default class BaseKeyboard extends Vue {
  @Prop()
  public title;
  @Prop()
  /** 当点击键盘外部时，需要关闭键盘；但是点击关联元素不应该关闭，可以使用这个参数排除 */
  public exclude: Node | Node[] | ((current: Node) => boolean);
  @Prop({ default: '' })
  public theme: string;

  public fnBodyClick: undefined | ((event: Event) => void) = undefined;

  public mounted() {
    if (globalKeyboard) {
      globalKeyboard.handleClose();
    }
    globalKeyboard = this;

    this.fnBodyClick = (e) => {

      if (!utils.isParentOfEventElement(this.$refs.basekeyboard as any, e)) {
        let isExclude = false;
        const target = e.target as Node;
        if (_.isArray(this.exclude)) {
          isExclude = this.exclude.includes(target);
        } else if (_.isFunction(this.exclude)) {
          isExclude = this.exclude(target);
        } else if (this.exclude === target) {
          isExclude = true;
        }
        if (!isExclude) {
          this.handleClose();
        }
      }
    };
    document.body.addEventListener('touchstart', this.fnBodyClick, true);
  }
  public destroyed() {
    if (this.fnBodyClick) {
      document.body.removeEventListener('touchstart', this.fnBodyClick, true);
    }
  }
  public handleClose() {
    this.$emit('close');
  }

  public enter(el, done) {
    el.style['max-height'] = '0px';
    Velocity(el,
      {
        'max-height': '100%',
      },
      {
        duration: 200,
        complete: done,
      });
  }
  public leave(el, done) {
    el.style['max-height'] = '100%';
    Velocity(el,
      {
        'max-height': '0px',
      },
      {
        duration: 100,
        complete() {
          done();
        },
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/common/BaseKeyboard/BaseKeyboard.ts